import React from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.compose';
import { translate } from 'react-i18next';

function PressurePlateDetails({ product: { parameter, meta }, t }) {
  return (
    <div className="table-wrapper">
      <div className="div-table details-table">
        <div className="div-table-body">
          {parameter && (
            <div className="div-table-row">
              <div className="div-table-cell">{t('pressure_plate_details.parameter')}</div>
              <div className="div-table-cell">{parameter}</div>
            </div>
          )}
          <div className="div-table-row">
            <div className="div-table-cell">{t('pressure_plate_details.facing_size')}</div>
            <div className="div-table-cell">{meta.facing_size || '-'}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

PressurePlateDetails.defaultProps = {};
PressurePlateDetails.propTypes = {
  product: PropTypes.shape({
    meta: PropTypes.shape({
      facing_size: PropTypes.string
    })
  })
};
export default compose(
  translate('product'),
)(PressurePlateDetails);

